<template>
  <div
    class="-mt-[72px] overflow-hidden bg-blue pb-10 pt-[72px] lg:-mt-24 lg:h-screen lg:min-h-[800px] lg:pt-24"
  >
    <div class="p-0 pt-10 lg:container lg:py-20">
      <div class="grid-default px-4 lg:px-0">
        <div class="col-span-8 lg:col-end-7">
          <Heading
            is-hero-heading
            :semantic="isSemantic"
            :level="level"
            class="mb-6 text-4xl font-light text-white transition-opacity duration-300 lg:mb-0 xl:text-6xl"
            @completed="heroAnimated = true"
          >
            {{ data.title }}
          </Heading>
        </div>
        <div
          class="col-span-6 transition-opacity duration-300 lg:col-start-7"
          :class="heroAnimated ? 'opacity-100' : 'opacity-0'"
        >
          <div
            class="mb-6 text-base font-light text-white lg:mb-0 lg:text-2xl"
            v-html="data.html"
          ></div>
        </div>
      </div>
      <div class="relative lg:pt-10">
        <div
          v-if="data.buttons.length"
          class="relative z-2 flex items-center gap-3 px-4 transition-opacity duration-300 lg:gap-8 lg:px-0"
          :class="heroAnimated ? 'opacity-100' : 'opacity-0'"
        >
          <CircleButton
            iconName="arrow-right"
            color="orange"
            :size="isDesktop ? 'lg' : 'md'"
            class="bg-blue"
            :to="
              data.buttons[0].reference !== null
                ? localePathByType(
                    data.buttons[0].reference?.__typename as string,
                    data.buttons[0].reference?.slug as string
                  )
                : data.buttons[0].externalLink
            "
          />
          <span class="text-xl font-medium text-white lg:text-2xl">{{
            data.buttons[0].label
          }}</span>
        </div>
        <div class="relative z-1 flex flex-row items-center px-4 lg:px-0">
          <div class="flex justify-center pl-3 text-xl font-medium text-white lg:pl-5 lg:text-2xl">
            {{ data.subtitle }}
          </div>
        </div>
        <div v-if="data.media" class="lg:absolute lg:left-1/2 lg:top-5 lg:z-0 lg:-translate-x-1/2">
          <Image
            class="aspect-video h-auto w-auto max-w-[900px] object-cover"
            :src="data.media.responsiveImage ? data.media.responsiveImage?.src : data.media.url"
            :srcset="
              data.media.responsiveImage ? data.media.responsiveImage?.webpSrcSet : undefined
            "
            :width="
              data.media.responsiveImage ? data.media.responsiveImage?.width : data.media.width
            "
            :height="
              data.media.responsiveImage ? data.media.responsiveImage?.height : data.media.height
            "
            :alt="data.media?.alt!"
            effect="none"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from '~/stores/AppStore'
import type { SectionHero2Record } from '~/types/generated'

const store = useAppStore()
const { localePathByType } = useLocalePathByType()
const { isDesktop } = useDevice()
const heroAnimated = ref(false)

const props = defineProps({
  data: {
    type: Object as PropType<SectionHero2Record>,
    default: () => {}
  },
  index: {
    type: Number,
    required: true
  }
})

const { level, isSemantic } = useSectionRules(props.index, !!props.data.title)

onMounted(() => {
  store.setTheme('blue')
})
</script>
